<div class="server-settings-root">
	<h1 style="margin-bottom: 20px;">ITGlue Settings</h1>
	<form [formGroup]="form">
		<div class="form-group row mb-3">
			<div>
				<input type="checkbox" [formControl]="enabled" />
				<span class="uv-checkbox-label">Enable ITGlue</span>
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !serverURL.value}">
			<span class="col-lg-2">Server URL:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="serverURL" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !apiServerURL.value}">
			<span class="col-lg-2">API Server URL:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="apiServerURL" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !apiKey.value}">
			<span class="col-lg-2">API Key:</span>
			<div class="col-lg-5">
				<input class="form-control" type="password" [formControl]="apiKey" (keydown)="onPasswordKeyDownHandler($event)"/>
			</div>
		</div>
		<div class="itglue-default-settings-divider"></div>
		<div class="row" style="padding-top: 10px;">
			<div style="height: 21px; width: 250px;">
				<button pButton (click)="onSave()" [disabled]="!form.dirty" label="Save ITGlue Default Settings"></button>
			</div>
			<div style="height: 21px; width: 250px;">
				<button pButton (click)="testConnection()" [disabled]="!enableTestITGlueButton" title="Test/Verify ITGlue connection credentials" label="Test ITGlue Connection"></button>
			</div>
		</div>
		<div class="itglue-default-settings-divider"></div>
	</form>
</div>